$(document).on('turbolinks:load', function () {
  if ($('body').is('[data-js-page-id="static_page#contact_us"]')) {
    console.log('static_page#contact_us page setup');
    ContactForm.init();
  }
});
